import { Card, CardContent, createStyles, fade, makeStyles } from "@material-ui/core";
import React from "react";
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";


const useStyles = makeStyles((theme: IYoelloTheme) => createStyles({
    root: {
        cursor: "pointer",
        width: "100%",
        height: "4rem",
        backgroundColor: theme.palette.background.default,
        color: "#616161",
        borderRadius: "0.5rem",
        marginBottom: "1rem",
        "&:hover": {
            border: `1px solid ${theme.palette.primary.main}AA`
        },
        "&:active": {
            border: `1px solid ${theme.palette.primary.main}DD`
        }
    },
    active: {
        border: `1px ${theme.palette.primary.main} solid`,
        textShadow: "0px 0px 1px",
        boxShadow: `0px 0px 1px ${theme.palette.primary.main}, 
                    0px 0px 2px ${theme.palette.primary.main},
                    0px 0px 3px ${theme.palette.primary.main}99`,
        fontWeight: 600,
        backgroundColor: fade(theme.palette.primary.main, 0.1)
    },
    content: {
        padding: '1rem'
    }
}));

interface IAcquirerCardsProps {
    active: boolean;
    title: string;
    id: string;
    onClick: (id: string) => void;
}

export function AcquirerCards({
    active,
    title,
    id,
    onClick
}: IAcquirerCardsProps) {
    const classes = useStyles();
    const activeClass = active ? classes.active : "";
    return <Card key={id} onClick={() => onClick(id)} className={`${classes.root} ${activeClass}`}>
        <CardContent className={classes.content}>
            {title}
        </CardContent>
    </Card>
}